export default "__VITE_ASSET__IB$048Xc__"